import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
const UPLOAD_TYPES = {
  local: "LOCAL",
  remote: "REMOTE",
};

const AddStep1 = ({ sleeve, hasError, gotoStep2, handleChangeExtUrl, handleUploadImage }) => {
  const [uploadType, setUploadType] = useState(null);

  const showUploadLocal = () => {
    setUploadType(UPLOAD_TYPES.local);
  };
  const showUploadRemote = () => {
    setUploadType(UPLOAD_TYPES.remote);
  };
  return (
    <div className="step-1" ng-show="step1">
      <Row>
        <Col xs={12} sm={5}>
          <div className="panel" onClick={showUploadLocal}>
            <div className="action">I have a URL of a sleeve i found online</div>
            {uploadType === UPLOAD_TYPES.local && (
              <div className="upload-preview add-step-item step-1-a">
                <label className="col-md-12">Image URL:</label>
                <div className="col-xs-12 form-group">
                  <input
                    autoFocus
                    id="ext_url"
                    name="ext_url"
                    type="url"
                    placeholder=""
                    className="form-control input-sm"
                    onChange={handleChangeExtUrl}
                    style={hasError ? { border: "2px solid red" } : null}
                  />
                  <i className="fa fa-exclamation-circle error"></i>
                  {sleeve.ext_url && !hasError && <i className="fas fa-check-circle" style={{ color: "green" }}></i>}

                  <div className="col-xs-12 help">example: https://www.web.com/cover.jpg</div>

                  {sleeve.ext_url && !hasError && (
                    <div>
                      <img src={sleeve.ext_url} className="img-responsive img-preview" />
                    </div>
                  )}
                  {sleeve.ext_url && !hasError && (
                    <div className="next">
                      <p className="note">If the image above looks good then continue</p>
                      <button className="btn-primary" onClick={gotoStep2}>
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Col>
        <Col xs={12} sm={2} className="col-or">
          <strong>OR</strong>
        </Col>
        <Col xs={12} sm={5}>
          <div className="panel" onClick={showUploadRemote}>
            <div className="action">I have an image of a sleeve on my computer</div>
            {uploadType === UPLOAD_TYPES.remote && (
              <div ng-show="haveLocalImage" className="add-step-item step-1-b">
                <div className="upload-preview">
                  <label className="col-md-12" htmlFor="img_upload">
                    <i className="fa fa-upload"></i> Upload Image
                  </label>

                  {/* <p ng-show="imageSrcLoading">
                        <i className="fa fa-refresh fa-spin"></i> Image loading...
                      </p> */}
                  {sleeve.img_upload_url && (
                    <span className="img-upload" ng-show="imageSrc">
                      <span>
                        <strong>* Image Preview *</strong>
                      </span>
                      <img img-fix-orientation="imageSrc" src={sleeve.img_upload_url} className="img-responsive" />
                    </span>
                  )}

                  {!sleeve.img_upload_url && (
                    <input
                      type="file"
                      id="img_upload"
                      name="img_upload"
                      className="input-file"
                      accept="image/jpg, image/jpeg, image/png"
                      maxsize="10000"
                      onChange={handleUploadImage}
                    />
                  )}

                  {sleeve.img_upload_url && (
                    <div className="next">
                      <button className="btn-primary" onClick={gotoStep2}>
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

AddStep1.propTypes = {
  // bla: PropTypes.string,
};

AddStep1.defaultProps = {
  // bla: 'test',
};

export default AddStep1;
